import { apiSlice } from "../API/apiSlice";

export const teamMemberApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeamMembers: builder.query({
      query: () => "/team",
    }),
    getTeamMember: builder.query({
      query: (tmId) => `/team/${tmId}`,
    }),
  }),
});

export const { useGetTeamMembersQuery, useGetTeamMemberQuery } = teamMemberApi;
